import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { CmsLinkComponent } from '@spartacus/core';

import { DpCmsFlexComponent } from '@app/core/cms-flex/components';
import { DpGtmService } from '@app/core/services/gtm.service';

import { FlexibleContentSectionData } from '../types';

@Component({
    selector: 'dp-flexible-content-section',
    templateUrl: './flexible-content-section.component.html',
    styleUrl: './flexible-content-section.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DpFlexibleContentSectionComponent extends DpCmsFlexComponent<FlexibleContentSectionData> {
  readonly #gtmService = inject(DpGtmService);

  getTarget(data: CmsLinkComponent): string | null {
    return data.target === 'true' || data.target === true ? '_blank' : null;
  }

  onPushGtmEvent(props: FlexibleContentSectionData): void {
    this.#gtmService.pushSimpleTag('flexible_section_click', { componentId: props.uid, buttonId: props?.link?.uid });
  }
}
